import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './components/ui/Card';
import {X} from 'lucide-react';


const About = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-4 flex flex-col items-center">

      
      <img 
        src="/images/end-credits-logo.png" 
        alt="End Credits Logo" 
        className="w-full max-w-md h-auto cursor-pointer mb-6 transition-transform duration-300 ease-in-out hover:scale-105"
        onClick={() => navigate('/')}
      />
      
      <img 
        src="/images/movieFriends.png" 
        alt="Movie Friends" 
        className="w-full max-w-xl h-auto mb-8"
      />

      <Card className="w-full max-w-4xl mx-auto mb-8 relative"> {/* Add relative to position the button */}
        <CardHeader>
          <CardTitle className="text-2xl font-bold">About End-Credits</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="mb-4">
            End-Credits is designed to help movie enthusiasts discover if films have post-credit scenes, ensuring you never miss those hidden extras or teasers. Whether you're planning a trip to the cinema or a movie night at home, we've got you covered with up-to-date information on recent + past releases.
          </p>
          <p className="mb-4">
            No more scrolling through cluttered, ad-filled articles. End-Credits provides clear, straightforward answers about whether you should stay for the credits.
          </p>
          <p>
            Please note, the site may experience performance issues with high traffic. If you find the service helpful, consider donating to support continued development.          </p>
        </CardContent>

        <button 
          onClick={() => navigate(-1)} 
          className="absolute top-2 right-2 p-1 rounded-full bg-gray-800 opacity-70 hover:opacity-100"
        >
          <X className="h-4 w-4 text-white" />
        </button>

        <div className="w-full max-w-md mx-auto">
        <img 
          src="/images/cashApp.png" 
          alt="Cash App QR Code" 
          className="w-full h-auto"
        />
        <p className="text-center mt-2 text-gray-600">Support us (Ryan) by scanning the QR code above</p>
      </div>
      </Card>
    </div>
  );
};

export default About;
